// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2NSgN","right":"styles_right__RAs0Z"};